export default __webpack_public_path__ + "static/media/depenses-active.fe7b2985.svg";